import cssUtil from 'gw-portals-util-js/CssUtil';

import template from 'text!./BadgeDirective.html';
import styles from './BadgeDirective-hashed.scss';

var hashedTemplate = cssUtil.hashTemplate(template, styles);

export default [function () {
    return {
        restrict: 'E',
        transclude: true,
        replace: true,
        template: hashedTemplate,
        scope: {
            type: '@',
            flavor: '@'
        },
        controller: ['$scope', function ($scope) {
            $scope.styles = styles;
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/badge/BadgeDirective.js
// module id = 1094
// module chunks = 0